import { render } from "./sjgl.vue?vue&type=template&id=0f75e804"
import script from "./sjgl.vue?vue&type=script&lang=js"
export * from "./sjgl.vue?vue&type=script&lang=js"

import exportComponent from "D:\\智诚大数据\\禁种铲毒\\禁种铲毒平台\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__